import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  outlinedWarningButton: {
    color: theme.palette.warning.main,
    borderColor: theme.palette.warning.main,
    '&:hover': {
      borderColor: theme.palette.warning.dark,
    },
  },
  containerWarningButton: {
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    },
  },
  planActionTitle: {
    alignSelf: 'center',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
}))

export default styles
